import { enqueueReport } from "@infrastructure/reportQueue";
import { ConnectionDiagnosticsSnapshot } from "@infrastructure/websocket/WebSocketConnection";
import { BigBashEvent, Game } from "@/types/types";
import { DelayProblemReport } from "./types/delayProblemReport";

export const DELAY_PROBLEM_MESSAGE = 'Moderator reported a delay problem';

export function reportDelayProblem(event: BigBashEvent, game: Game, connectionDiagnostics: ConnectionDiagnosticsSnapshot | null): Promise<void> {
	const report: DelayProblemReport = {
		pressedAt: new Date().toISOString(),
		eventId: event.id,
		eventName: event.name,
		gameId: game.id,
		gameName: game.name,
		room: game.default_room,
		connectionDiagnostics,
	};
	return enqueueReport(DELAY_PROBLEM_MESSAGE, report as Record<string, unknown>);
}
